<mat-form-field [ngClass]="classes" class="fill override-hide-placeholder">
  @if (label && !(classes && classes.includes('inline'))) {
    <mat-label>{{label}}</mat-label>
  }
  @if (label && (classes && classes.includes('inline'))) {
    <label>{{label}}</label>
  }
  @if (!label) {
    <mat-label></mat-label>
  }
  <mat-select (openedChange)="openedChange($event)"
    (selectionChange)="emitSelect($event)"
    [formControl]="selectFormControl"
    panelClass="select-search-dropdown-panel select-search-single"
    [compareWith]="compareWith"
    placeholder="{{selectFormControl.value?stringFunction(selectFormControl.value, value_map) : placeholder }}"
    #select_search>

    @if (selectFormControl.value?.attributes) {
      <mat-select-trigger [dblClickCopy]="selectFormControl.value?.attributes?.name"
        (debounceClick)="select_search.open()"
        [appProcessMenu]="selectFormControl.value">
        {{description_map[selectFormControl?.value?.id] || (selectFormControl.value?.attributes | nameAndDescription)}}
      </mat-select-trigger>
    }

    <div class="dropdown-container">
      <div class="row center sticky">
        <mat-form-field class="no-label">
          <input #search matInput class="search-dropdown"
            [formControl]="searchTextboxControl"
            (keydown.space)="$event.stopPropagation()"
            placeholder="{{searchPlaceholder}}">
          @if (searchTextboxControl.value) {
            <i
              matSuffix
              class="fa fa-times clear-filter"
              matTooltip="Clear search"
              (click)="clearSearch($event)">
            </i>
          }
        </mat-form-field>

      </div>
      @if (filteredOptions && filteredOptions.length == 0) {
        <mat-optgroup>
          <div>No results found!</div>
          <mat-option [value]="null" [disabled]="true"></mat-option>
        </mat-optgroup>
      }
      @if (selectFormControl.value && selectFormControl.value.attributes) {
        <mat-option
          [value]="selectFormControl.value"
          class="with-account-row">
          <span class="select-item-name" [dblClickCopy]="selectFormControl.value?.attributes?.name"
            [appProcessMenu]="selectFormControl.value"
          style="color: #666666;">{{selectFormControl.value.attributes | nameAndDescription}}</span>
          <span class="account-name select-item-account-name">Selected</span>
        </mat-option>
      }
      <cdk-virtual-scroll-viewport itemSize="30" minBufferPx="400" maxBufferPx="10000"
        style="height: 200px; overflow-x: hidden; background: white;">

        <mat-option *cdkVirtualFor="let option of filteredOptions"
          [ngClass]="{'with-account-row': option.attributes?.account_name}"
          [style.font-weight]="selectFormControl.value && selectFormControl.value.id==option.id ? 'bold' : 'normal'"
          [title]="description_map[option.id]"
          [value]="value_map[option.id]">
          <span class="select-item-name" [appProcessMenu]="option">
          {{description_map[option.id]}}</span>
          @if (option.attributes?.account_name && isOpen) {
            <span
              class="account-name select-item-account-name">
            {{option.attributes.account_name.trim()}}</span>
          }
        </mat-option>

      </cdk-virtual-scroll-viewport>

    </div>
  </mat-select>
</mat-form-field>

<!-- Copyright 2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license -->
